import { Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';
import { DatumOutputType, TabulationClassification } from '@rds/rds-base-ts';
import { RdsCodeDisplayType } from '@rds/shared-api';

import { RdsGetDatumValuePipe } from './get-datum-value.pipe';
import { DatumCell } from './models/datum-cell.model';

@Pipe({
  name: 'rdsGetHeaderCellValue',
})
export class RdsGetHeaderCellValuePipe implements PipeTransform {
  constructor(private datumValuePipe: RdsGetDatumValuePipe) {}
  transform(
    displayType: RdsCodeDisplayType,
    value: DatumCell,
    columnLookupLength: number,
    variables: Array<Variable | VariableSummary | null>,
    classifications: { [id: string]: TabulationClassification },
    map: { [id: string]: string[] },
    measureColumnHeader: string
  ): DatumOutputType | null {
    if (value.subtotal && value.id === 'row-total') {
      return columnLookupLength ? 'TOTAL' : measureColumnHeader;
    } else if (value.subtotal) {
      return 'Subtotal';
    } else {
      return this.datumValuePipe.transform(displayType, value.datumStack[value.datumStack.length - 1], variables, classifications, map);
    }
  }
}
